import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "app/services/auth.service";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const authToken = inject(AuthService).getAuthToken();
  if (authToken) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `${authToken}`)
    });
    return next(authReq);
  }
  return next(req);
}